module.exports = __webpack_public_path__ + "assets/img/FACTURACION_1.03b55893.svg";